import { isPlainObject } from '../utils/common/base';

export default {
  site: '',
  page: '',
  pageName: '',
  customParam: '',
  referer: '',
  uid: '',
  method: '',
  nGuid: '',
  nCtid: '',
  nLiu: '',
  cst: '',
  screen: '',
  plat: '',
  type: '',
  action: '',
  getCookie(sKey) {
    if (!sKey || !this.hasItem(sKey)) {
      return null;
    }
    return decodeURIComponent(document.cookie.replace(new RegExp(`(?:^|.*;\\s*)${encodeURIComponent(sKey).replace(/[-.+*]/g, '\\$&')}\\s*\\=\\s*((?:[^;](?!;))*[^;]?).*`), '$1'));
  },
  hasItem(sKey) {
    return (new RegExp(`(?:^|;\\s*)${encodeURIComponent(sKey).replace(/[-.+*]/g, '\\$&')}\\s*\\=`)).test(document.cookie);
  },
  track(tParams) {
    this.buildParams();

    let src = '';
    const script = document.createElement('script');
    const params = [];
    let content = '';

    if (typeof (tParams) === 'undefined' || typeof (tParams.target_url) === 'undefined') {
      src = `//s.anjuke.com/st?__site=${encodeURIComponent(this.params.site)}&`;
    } else {
      src = `${tParams.target_url}?`;
    }
    const { keys } = Object;
    keys(this.params).forEach((k) => {
      params.push(`${k}=${encodeURIComponent(this.params[k])}`);
    });
    src += params.join('&');
    script.src = src;
    script.async = true;
    content = (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]);
    script.onload = () => {
      content.removeChild(script);
    };
    content.appendChild(script);
  },
  buildParams() {
    const { href } = document.location;
    const guid = this.getCookie(this.nGuid || 'aQQ_ajkguid');
    const ctid = this.nCtid || this.getCookie(this.nCtid || 'ctid');
    const luid = this.getCookie(this.nLiu || 'lui');
    const ssid = this.getCookie(this.nSessid || 'sessid');
    let uid = this.getCookie(this.nUid || 'ajk_member_id');
    this.setUid(uid);

    if (uid === undefined || uid == null || uid === '') {
      uid = 0;
    }

    let method = '';
    if (this.method !== undefined && this.method != null) {
      ({ method } = this);
    }

    this.params = {};
    this.params.p = this.page;
    this.params.h = href;
    this.params.r = this.referer;
    this.params.site = this.site;
    this.params.guid = guid;
    this.params.ssid = ssid;
    this.params.uid = uid;
    this.params.t = new Date().getTime();
    this.params.ctid = ctid;
    this.params.luid = luid;
    this.params.m = method;

    if (this.screen !== undefined) {
      this.params.sc = JSON.stringify(this.screen);
    }

    if (this.cst !== undefined && /[0-9]{13}/.test(this.cst)) {
      this.params.lt = this.params.t - parseInt(this.cst, 10);
    }

    if (this.pageName !== undefined) {
      this.params.pn = this.pageName;
    }

    if (this.customParam !== undefined) {
      this.params.cp = this.customParam;
    }

    if (this.plat !== undefined) {
      this.params.plat = this.plat;
    }
    if (this.type !== undefined) {
      this.params.type = this.type;
    }
    if (this.action !== undefined && this.action !== '') {
      this.params.action = this.action;
    }
  },
  setSite(s) {
    if (s !== undefined && s != null) {
      this.site = s;
    }
  },
  setPage(p) {
    if (p !== undefined && p != null) {
      this.page = p;
    }
  },
  setPageName(n) {
    this.pageName = n;
  },
  setCookieNames(c) {
    this.cookNames = c;
  },
  setReferer(r) {
    if (r !== undefined && r != null) {
      this.referer = r;
    }
  },
  setUid(u) {
    if (u !== undefined && u != null) {
      this.uid = u;
    }
  },
  setMethod(m) {
    this.method = m;
  },
  setNGuid(n) {
    this.nGuid = n;
  },
  setNCtid(n) {
    this.nCtid = n;
  },
  setNLiu(n) {
    if (n !== undefined && n != null) {
      this.nLiu = n;
    }
  },
  setNSessid(n) {
    if (n !== undefined && n != null) {
      this.nSessid = n;
    }
  },
  setNUid(n) {
    if (n !== undefined && n != null) {
      this.nUid = n;
    }
  },
  setCst(n) {
    this.cst = n;
  },
  setScreen(v) {
    this.screen = v;
  },
  setPlat(v) {
    this.plat = v;
  },
  setType(v) {
    this.type = v;
  },
  setAction(v) {
    this.action = v;
  },
  setCustomParam(v) {
    let sojSourceH5 = { source_h5: { app: '', os: '', ver: '' } };
    const sourceH5 = document.getElementsByTagName('body')[0].dataset.sourceh5;
    let jsondata = {};
    let vT = '';
    try {
      if (sourceH5 && sourceH5.length > 0) { sojSourceH5 = JSON.parse(sourceH5); }
    } catch (e) {
      console.log(e);
    }
    try {
      if (!v) {
        if (sojSourceH5) { vT = JSON.stringify(sojSourceH5); }
      } else {
        if (!isPlainObject(v)) {
          jsondata = JSON.parse(v);
        } else {
          jsondata = v;
        }
        if (!Object.prototype.hasOwnProperty.call(jsondata, 'source_h5')) {
          if (sojSourceH5) { jsondata.source_h5 = sojSourceH5; }
        }
        vT = JSON.stringify(jsondata);
      }
    } catch (e) {
      if (!vT) {
        if (sojSourceH5) { vT = JSON.stringify(sojSourceH5); }
      } else {
        if (isPlainObject(vT)) {
          vT = JSON.stringify(vT);
        }
        const a = vT.split('');
        if (sojSourceH5) { a[0] += JSON.stringify(sojSourceH5); }
        vT = a.join('');
      }
    }
    this.customParam = vT;
  },
  getParams() {
    return this.params;
  },
};
